import React from 'react'
import { Box, Text } from '@chakra-ui/react'
import { ToggleButton } from '@nucba-coding/nucba-ui'

export type LinkToPostProps = {
  name: string
  slug?: string
  onClick?: (slug: string) => void
}

export const LinkToPost = ({ name, slug = '', onClick }: LinkToPostProps) => (
  <Box
    cursor={'pointer'}
    display={'flex'}
    opacity={0.8}
    userSelect={'none'}
    width={'100%'}
    flexDirection={'row'}
    justifyContent={'space-between'}
    alignItems={'center'}
    _hover={{ opacity: 1, bg: '#202020' }}
    _active={{ opacity: 0.8 }}
    borderRadius={'8px'}
    onClick={() => onClick && onClick(slug)}
  >
    <Text fontSize={'20px'} fontWeight={500} color={'#a2a2a2'} p={'10px 20px'}>
      {name}
    </Text>
    <ToggleButton mr={4} w={7} h={7} toggle={() => console.log('')} />
  </Box>
)
